<template>
  <section class="TcLoginDni h-full">
    <div v-if="loading" class="container px-5 mx-auto flex flex-col items-center justify-center gap-5 h-full pb-5">
      <h2 class="text-2xl">Intentando conectar con el servicio de lector del DNIe</h2>
      <h3>Por favor espere...</h3>
      <TcIcon class="h-6 w-6 animate-spin" icon="hourglass"></TcIcon>
    </div>
    <div v-else class="container px-5 mx-auto flex flex-col items-center justify-center gap-5 h-full pb-5">
      <template v-if="grant">
        <h2 class="text-2xl">DNI Válido</h2>
        <p>Tratando de validar al usuario</p>
        <p>Por favor espere...</p>
        <TcIcon class="h-6 w-6 animate-spin" icon="hourglass"></TcIcon>
      </template>
      <template v-else>
        <h2 class="text-2xl">DNI inválido</h2>
        <p>{{ msg }}</p>
        <p>Por favor compruebe que el DNIe se encuentra dentro del lector e inténtelo de nuevo</p>
        <button @click="goDni" class="mt-5 mb-3" style="width:300px;">Validar DNIe</button>
        <button @click="goWelcome" class="btn-secondary" style="width:300px;">Volver al inicio</button>
      </template>
    </div>
  </section>
</template>

<script>
//NOTA: si consigo la codificación volver a descomentar.
//import iconv from 'iconv-lite'
import TcIcon from './TcIcon.vue';
export default {
  name: 'TcLoginDni',
  components: {
    TcIcon,
  },
  data () {
    return {
      loading: true,
      grant: false,
      msg: '',
    }
  },
  methods: {
    goDni: function() {
      this.loading = true;
      this.grant = false;
      this.msg = '';
      setTimeout(this.validateLogin, 1000)
    },
    goWelcome: function() {
      window.location.reload();
    },
    validateLogin: function() {
      //console.log('validateLogin');
      fetch(this.$root.login_dni_url()).then(response => response.json())
      .then(json => {
        this.loading = false;
        //console.log('JSON DNI', json);
        if(json.status && json.status=='OK') {
          this.grant = true;
          // EL DNI electrónico es correcto
          // Ahora se intenta buscar el usuario para obtener un token
          fetch('/auth-dni.php', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              username: json.data.dni,
              password: json.data.dni,
            }),
          }).then(response => response.json())
          .then(auth => {
            if(auth && auth.access_token) {
              this.$root.setAccessToken(auth.access_token);
              this.$root.setPage('home');
            } else {
              //Voy a intentar hacer la conversión de charset, me rindo, la versión de otros totems. Algun día sabré q codificación es la de origen
              /*
              json.data.name     = iconv.decode(json.data.name    , 'iso8859_15').toString();
              json.data.surname1 = iconv.decode(json.data.surname1, 'iso8859_15').toString();
              json.data.surname2 = iconv.decode(json.data.surname2, 'iso8859_15').toString();
              */
              //Si no lo consigo... lo que hizo octavio en otros totmes. Cambiar el caracter de reemplazo por un Ñ... a fuego
              json.data.name    = json.data.name.replace(/\uFFFD/g, 'Ñ').replace(/\ufffd/g, 'Ñ');
              json.data.surname1= json.data.surname1.replace(/\uFFFD/g, 'Ñ').replace(/\ufffd/g, 'Ñ');
              json.data.surname2= json.data.surname2.replace(/\uFFFD/g, 'Ñ').replace(/\ufffd/g, 'Ñ');

              this.$root.external_user = json.data;
              this.$root.setPage('login-public');
            }
          }).catch(error => {
            console.error('SE HA PRODUCIDO UN ERROR EN TcLoginDni en oAuth', error);
          });
        } else {
          this.grant = false;
        }
      })
      .catch(error => {
        this.grant = false;
        this.msg = error;
        this.loading = false;
        console.error('SE HA PRODUCIDO UN ERROR EN TcLoginDni', error);
      })
    }
  },
  mounted() {
    //console.log('TcLoginDni MOUNTED');
    this.validateLogin();
  }
}
</script>